import React, {useEffect, useState} from 'react';
import DOMPurify from 'dompurify';
import {Container, Spinner} from 'react-bootstrap';

// :NOTE: terms and conditions and privacy policy live here
export function PrivacyPolicyPage() {
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/docs/PrivacyPolicy.html')
      .then(async response => response.text())
      .then(text => {
        // Sanitize if the file is not 100% trusted
        const clean = DOMPurify.sanitize(text);
        setHtml(clean);
        setLoading(false);
      })
      .catch((error: unknown) => {
        console.error(error);
        setLoading(false);
      });
  }, []);

  return (
    <Container className='my-5'>
      {loading ? (
        <div className='text-center'>
          <Spinner animation='border' role='status'>
            <span className='visually-hidden'>Loading...</span>
          </Spinner>
        </div>
      ) : (
        <div dangerouslySetInnerHTML={{__html: html}} />
      )}
    </Container>
  );
}

export function TermsAndConditionsPage() {
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/docs/TermsAndConditions.html')
      .then(async response => response.text())
      .then(text => {
        // Sanitize if the file is not 100% trusted
        const clean = DOMPurify.sanitize(text);
        setHtml(clean);
        setLoading(false);
      })
      .catch((error: unknown) => {
        console.error(error);
        setLoading(false);
      });
  }, []);

  return (
    <Container className='my-5'>
      {loading ? (
        <div className='text-center'>
          <Spinner animation='border' role='status'>
            <span className='visually-hidden'>Loading...</span>
          </Spinner>
        </div>
      ) : (
        <div dangerouslySetInnerHTML={{__html: html}} />
      )}
    </Container>
  );
}

const tnC = {};

export default tnC;
